import { Currencies, EntityTypes } from '@wg/wows-entities/const';

import { currencyNamesToWE } from '~/UIKit/Currency/Currency';

import type { Nullable } from '~/types/generics';

import type { IPatrol, IPatrolBundle, IPatrolReward, IPatrolRewardId, IPatrolRewardItem } from '~/types/patrols';

const CurrenciesList = Object.values(Currencies);

export function getRewardsObjectByBundlesList(bundles: IPatrolBundle[]): Record<IPatrolRewardId, IPatrolReward> {
  return bundles.reduce(
    (acc, bundle) => {
      bundle.rewards.forEach((reward) => {
        if (!acc[reward.id]) {
          acc[reward.id] = reward;
        }
      });
      return acc;
    },
    {} as Record<IPatrolRewardId, IPatrolReward>,
  );
}

export const getPatrolRewardItemDataWE = (item: IPatrolRewardItem) => {
  if (item.currency) {
    return {
      type: EntityTypes.CURRENCY,
      id: currencyNamesToWE[item.currency] || item.currency,
    };
  }

  if (!item.id && CurrenciesList.includes(item.type as Currencies)) {
    return {
      type: EntityTypes.CURRENCY,
      id: item.type,
    };
  }

  return {
    type: item.type,
    id: item.id,
  };
};

type IPatrolStatuses = {
  isPatrolDisabled: boolean;
  isPatrolWillStart: boolean;
  isPatrolFinished: boolean;
  patrolStartTime: Nullable<number>;
  patrolEndTime: Nullable<number>;
};

export const getPatrolStatuses = (patrol: IPatrol): IPatrolStatuses => {
  const now = Date.now();

  const patrolStartTime = patrol.activeFrom !== null ? patrol.activeFrom * 1000 : null;
  const patrolEndTime = patrol.activeTill !== null ? patrol.activeTill * 1000 : null;

  const isPatrolWillStart = patrolStartTime !== null && patrolStartTime > now;
  const isPatrolFinished = patrolEndTime !== null && patrolEndTime < now;

  const isPatrolDisabled = isPatrolWillStart || isPatrolFinished;

  return {
    isPatrolDisabled,
    isPatrolWillStart,
    isPatrolFinished,
    patrolStartTime,
    patrolEndTime,
  };
};
